import { Box } from "@mui/material"
import { faTruck } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { FormikTextField } from "../../../../forms/Formik"

import type { CheckoutFormValues } from "./takeawayCheckoutLib"
import { TakeawayCheckoutSectionHeader } from "./TakeawayCheckoutSectionHeader"

export function TakeawayCheckoutCommentSection() {
    return (
        <Box>
            <TakeawayCheckoutSectionHeader
                icon={faTruck}
                title={
                    <LocalizedStrict id="takeaway-confirm-order-delivery-section-title">
                        <span>Delivery</span>
                    </LocalizedStrict>
                }
            />
            <LocalizedStrict id="takeaway-confirm-order-comment-placeholder" attrs={{ label: true }}>
                <FormikTextField<CheckoutFormValues>
                    name="orderComment"
                    fullWidth
                    multiline
                    minRows={1}
                    label="Write a comment (optional)"
                />
            </LocalizedStrict>
        </Box>
    )
}
